import styled from "styled-components";
import { theme } from "../../styles/theme";
import { BodyP, H6 } from "../../styles/stylesTypography";

export const Card = styled.div`
  width: 100%;
  max-width: 820px;
  padding: 24px 28px;

  display: flex;
  flex-direction: column;

  border-radius: 16px;
  background-color: ${theme.colors.gray.Cinza_13};
`;

export const Header = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  cursor: pointer;
`;

export const HeaderTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DateText = styled(BodyP)`
  color: ${theme.colors.gray.Cinza_7};
`;

export const Title = styled(H6)`
  @media only screen and (max-width: 768px) {
    font-size: 1rem;
    line-height: 1.3rem;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  flex-shrink: 0;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;

  border-radius: 50%;
  background-color: ${(props) =>
    props.$unread ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_9};
`;

export const ToggleButton = styled.button`
  width: 32px;
  height: 32px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 50%;
  cursor: pointer;
  background-color: ${theme.colors.white.Branco};

  transition: transform 0.3s ease;
  transform: ${(props) => (props.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};

  &:focus {
    outline: none;
  }

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const Content = styled(BodyP)`
  overflow: hidden;
  color: ${theme.colors.gray.Cinza_6};

  max-height: ${(props) => (props.$isOpen ? "2000px" : "0")};
  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  margin-top: ${(props) => (props.$isOpen ? "16px" : "0")};

  transition: max-height 0.4s ease, opacity 0.3s ease, margin-top 0.3s ease;
  pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};

  p,
  span,
  div,
  li {
    word-wrap: break-word;
  }

  p + p {
    margin-top: 2px;
  }

  a {
    color: ${theme.colors.blue.Azul_link};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;
